import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  title: 'Post-Lansare',
  subtitle: 'Vizualizați datele listei de verificare Go Live și setați data de screening post-lansare.',
  go_live_checklist: {
    labels: {
      yes: 'Da',
      no: 'Nu',
    },
    title: 'Listă de verificare Go Live',
    form: {
      is_google_business_available: {
        label: 'Google Business disponibil',
      },
      is_smart_pricing_configured: {
        label: 'Prețuri mai mici decât Lieferando, Wolt, Uber',
      },
      is_flyers_package_sent: {
        label: 'Flyer promoțional trimis',
      },
      is_menu_fully_configured: {
        label: 'Toate articolele din meniu disponibile',
      },
      has_offers_on_competitor_platforms: {
        label: 'Are restaurantul oferte active pe Wolt, Uber, Lieferando (cu excepția ofertei de livrare gratuită)?',
      },
      is_instagram_story_shared: {
        label: 'Povestea Instagram distribuită proprietarului',
      },
      is_order_system_connected_to_website: {
        label: 'Website Foodamigos conectat SAU buton comandă online adăugat pe website-ul propriu al restaurantului',
      },
      google_business_connected_by: {
        label: 'Cum am obținut acces la profilul Google Business?',
        options: {
          [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
            'Managerul de vânzări a invitat google@foodamigos.io',
          [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
            'Managerul de vânzări a trimis prima solicitare personal de pe telefonul proprietarului',
          [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
            'Managerul de onboarding a solicitat profilul Google Business (SM nu a invitat și nu a solicitat acces)',
          null: 'N/A',
        },
      },
    },
    buttons: {
      save: 'Salvează',
    },
    toasts: {
      success: 'Salvat cu succes',
      error: 'Salvarea a eșuat',
    },
  },
  post_launch_screening: {
    title: 'Screening Post-Lansare',
    form: {
      screening_date: {
        label: 'Data screening-ului',
      },
    },
    toasts: {
      success: 'Salvat cu succes',
      error: 'Salvarea a eșuat',
    },
    buttons: {
      save: 'Salvează',
    },
  },
};
